// Fades and lifts each homepage/page section into view on first scroll past
// it, plus a finer staggered cascade for individual text/image/tile elements
// (marked with the .reveal-item class). Sections and items are observed
// independently, so a very tall section (e.g. a large photo grid) still
// reveals its items one at a time as the user actually scrolls to each one,
// rather than all at once the moment the section's top appears.
// Progressive enhancement: if this never runs, everything is simply visible
// (see base.css — the hidden state only applies once this class is added).
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  document.documentElement.classList.add('supports-scroll-reveal');

  var sections = document.querySelectorAll(
    '#MainContent .shopify-section:not(.hero-image-wrapper)'
  );
  var items = document.querySelectorAll(
    '#MainContent .shopify-section:not(.hero-image-wrapper) .reveal-item'
  );

  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (el) {
      el.classList.add('is-revealed');
    });
    items.forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  function observe(elements, options) {
    if (elements.length === 0) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, options);
    elements.forEach(function (el) {
      observer.observe(el);
    });
  }

  // A tiny threshold (rather than e.g. 0.1) keeps this robust for very tall
  // sections too — a larger threshold measures against the *target's own*
  // height, so a section many viewports tall (a large photo grid) can
  // still read as "not intersecting" even while its top is fully on screen.
  observe(sections, { threshold: 0.01, rootMargin: '0px 0px -8% 0px' });
  observe(items, { threshold: 0.1, rootMargin: '0px 0px -8% 0px' });
})();
